namespace Matrix.Dashboards {
    export class DatasetColumns {
        static columnsKey = 'Dashboards.Dataset';
    }
}
